export default "__VITE_ASSET__d05931cf__"